export default __webpack_public_path__ + "static/ig-74f403a0fa17a4cb29af2f9329018197.svg";